import React, { Component } from "react";

import { BACKEND_CONFIG } from "../config/consts";
import headerImg from "../images/policy-actions.svg";
import requestQuoteChangeIcon from "../images/policy-actions-icons/icon-quotes-change-request.svg";
import bindRequestIcon from "../images/policy-actions-icons/icon-bind-request-view.svg";
import yourDocumentsIcon from "../images/policy-actions-icons/icon-policy-doc-view.svg";
import howToSubmitClaimIcon from "../images/policy-actions-icons/icon-message-alert.svg";
import editAppIcon from "../images/policy-actions-icons/icon-application-edit.svg";

import ChevronLink from "./actions-panel/ChevronLink";
import ExcessSurplusAction from "./ExcessSurplusAction";

class ActionsPanel extends Component {
  render() {
    return (
      <div className="four-panel">
        <div className="four-panel-main-header">
          <img alt="actions" src={headerImg} />{" "}
          <span className="four-panel-main-header-name">POLICY ACTIONS</span>
        </div>
        <div className="policy-actions">
          {this.props.displayRequestExcessSurplusQuotes &&
            this.requestExcessSurplusQuotesEnabled && (
              <ExcessSurplusAction
                clientId={this.props.clientId}
                excessSurplusQuotesRequested={
                  this.props.excessSurplusQuotesRequested
                }
                displayMessage={
                  this.props.excessSurplusQuotesRequested
                    ? "Alternative E&S quotes requested"
                    : "Request alternative E&S quotes"
                }
              />
            )}
          {this.props.displayEditApplication && (
            <EditApplicationAction clientId={this.props.clientId} />
          )}
          {this.props.showQuoteActions && (
            <>
              <RequestQuoteChange clientId={this.props.clientId} />
              <BindRequests clientId={this.props.clientId} />
            </>
          )}
          {this.props.showPolicyActions && (
            <>
              <YourDocuments clientId={this.props.clientId} />
              <SubmitAClaim />
            </>
          )}
        </div>
      </div>
    );
  }

  requestExcessSurplusQuotesEnabled() {
    return BACKEND_CONFIG.get("allstateRequestExcessSurplusSuspenseVisible");
  }
}

export default ActionsPanel;

function EditApplicationAction({ clientId }) {
  return (
    <ChevronLink
      to={"/client/" + clientId + "/edit-application"}
      icon={editAppIcon}
    >
      Edit Application
    </ChevronLink>
  );
}

function RequestQuoteChange({ clientId }) {
  return (
    <ChevronLink
      to={"/client/" + clientId + "/request-quote-change"}
      icon={requestQuoteChangeIcon}
    >
      Request Quote Change
    </ChevronLink>
  );
}

function BindRequests({ clientId }) {
  return (
    <ChevronLink to={"/client/" + clientId + "/orders"} icon={bindRequestIcon}>
      Bind Requests
    </ChevronLink>
  );
}

function YourDocuments({ clientId }) {
  return (
    <ChevronLink
      to={"/client/" + clientId + "/documents"}
      icon={yourDocumentsIcon}
    >
      Your Documents
    </ChevronLink>
  );
}

function SubmitAClaim() {
  return (
    <ChevronLink to={"/reference-tools/carrier"} icon={howToSubmitClaimIcon}>
      How to Submit a Claim
    </ChevronLink>
  );
}
